(async function () {
    // save the section id from the script tag and find the section
    const sectionID = document.currentScript.dataset.id;
    const section = document.querySelector(`#${sectionID}`);

    // exit if section is not found
    if (!section) {
        console.warn(`Product section with ID ${sectionID} not found.`);
        return;
    }

    // get the key values from the section
    const product = JSON.parse(section.querySelector(".productJSON").textContent);
    let activeVariant = JSON.parse(section.querySelector(".productVariantJSON").textContent);
    let quantity = 1;

    // during dev mode, set the active variant to the window so it can be accessed in the console
    if (Shopify.theme.role === "development") {
        window.product = product;
        window.activeVariant = activeVariant;
    }

    /************
     Product Swiper
     ************/
    const mainEl = document.querySelector('.productVisualSwiper');
    const thumbsEl = document.querySelector('.productVisualThumbs');

    if (!mainEl || !thumbsEl || typeof Swiper === 'undefined') return;

    // Destroy existing Swipers if reloaded in customizer
    if (mainEl.swiper) mainEl.swiper.destroy(true, true);
    if (thumbsEl.swiper) thumbsEl.swiper.destroy(true, true);

    const thumbs = new Swiper(thumbsEl, {
        spaceBetween: 10,
        slidesPerView: 5,
        freeMode: true,
        watchSlidesProgress: true
    });

    const productSwiper = new Swiper(mainEl, {
        slidesPerView: 1,
        spaceBetween: 20,
        loop: true,
        autoHeight: true,
        navigation: {
            nextEl: section.querySelector(".swiper-button-next"),
            prevEl: section.querySelector(".swiper-button-prev"),
        },
        thumbs: { swiper: thumbs },
        observer: true,
    observeParents: true,
        on: {
            slideChange: function () {
                if (!section.querySelector(".productVisualSwiperSlide")) {
                    return;
                }

                // pause all videos
                section.querySelectorAll(".productVisualSwiperSlide video").forEach(element => {
                    element.pause();
                });
            }
        }
    });

    // play video on slide play click
    section.querySelectorAll(".productVisualSwiperSlide").forEach(element => {
        element.addEventListener("click", function () {
            // get video
            const video = this.closest(".productVisualSwiperSlide").querySelector("video");

            if (!video) {
                return;
            }

            // remove play button if it hasn't already been removed
            this.querySelector(".productVisualSwiperSlidePlay")?.remove();

            // show controls
            video.controls = true;

            // play video
            video.play();
        });
    });

    // change slide on thumbnail click
    section.querySelectorAll(".productVisualThumbsSlide").forEach(element => {
        element.addEventListener("click", function () {
            // change slide
            productSwiper.slideTo(this.dataset.index - 1);
        });
    });

    /**************
     Update Product
     ***************/

    // update active variant on input changes
    section.querySelectorAll("input, select").forEach(function (element) {
        element.addEventListener("change", function () {
            updateProduct().catch(e => console.error(e));
        });
    })

    function isSubscription() {
        return !!section.querySelector(`.productFormSellingOptionHeaderInput:checked`) === true;
    }

    function currentSellingPlan() {
        return parseInt(section.querySelector('.productFormOptionsItemValuesLabelInput:checked').dataset.id);
    }

    let firstRun = true;

    async function updateProduct() {
        // Find the active variant
        if (product.variants.length === 1) {
            // default fallback
            activeVariant = product.variants[0];
        } else {
            // collect options from inputs
            let options = [];
            section.querySelectorAll(`.productFormOptionsItem`).forEach(group => {
                if (group.querySelector(`input:checked`).classList.contains('productFormSellingOptionHeaderInput')) return;
                options.push(group.querySelector(`input:checked`).value);
            });

            // find new variant based on the options
            activeVariant = product.variants.find((variant) => {
                return JSON.stringify(variant.options) === JSON.stringify(options)
            });
        }

        // check if variant wasn't found
        if (!activeVariant) {
            section.querySelector(".productATC").disabled = true;
            section.querySelector(".productATCText").textContent = "Not Available";
            return;
        }

        // update dynamic pay button
        document.querySelector('#productDynamicInput').value = activeVariant.id;

        // go to image if exists
        if (activeVariant.featured_image && !firstRun) {
            // change active slide
            productSwiper.slideTo(activeVariant.featured_image.position - 1);
        }

        // update prices
        section.querySelectorAll('.productFormOptionsItemValuesLabel')?.forEach(element => {
            // find the variant associated with this label
            let variant = JSON.parse(element.dataset.variant);
            let total = variant.price;
            let compare = variant.compare_at_price || 0;

            if (isSubscription()) {
                total = variant.selling_plan_allocations[0].price
                // metafield overwrites sub compare for some products
                if (!element.classList.contains('compare')) {
                    compare = variant.selling_plan_allocations[0].compare_at_price || 0;
                }
            }
            let save = compare - total;

            // update the prices
            element.querySelector('.productFormOptionsItemValuesLabelRightPrice').textContent = price(total);
            element.querySelector('.productFormOptionsItemValuesLabelRightCompare').textContent = '';
            element.querySelector('.productFormOptionsItemValuesLabelLeftSave').textContent = '';

            if (compare > total) {
                element.querySelector('.productFormOptionsItemValuesLabelRightCompare').textContent = price(compare);
                element.querySelector('.productFormOptionsItemValuesLabelLeftSave').textContent = `Save ${price(save)}`;
            }
        })

        let total = activeVariant.price;
        let compare = activeVariant.compare_at_price || 0;
        if (isSubscription()) {
            total = activeVariant.selling_plan_allocations[0].price
            // compare = activeVariant.selling_plan_allocations[0].compare_at_price || 0;
        }
        
        let save = compare - total;
        section.querySelector('.productPriceReal').textContent = price(total)
        section.querySelector('.productPriceCompare').textContent = '';
        section.querySelector('.productPriceSavings').textContent = '';
        if (compare > total) {
            section.querySelector('.productPriceCompare').textContent = price(compare)
            section.querySelector('.productPriceSavings').textContent = `Save ${price(save)}`;
        }

        /**************
         ATC Enable/Disable
         ***************/

        // enable the atc button
        section.querySelector(".productATC").disabled = false;

        // check if the variant is in stock
        if (activeVariant.available) {
            section.querySelector(".productATC").classList.remove("oos");
            section.querySelector(".productATCText").textContent = "Add To Cart";
        } else {
            section.querySelector(".productATC").classList.add("oos");
            section.querySelector(".productATCText").textContent = "Email me when back in stock";
        }


        // section.querySelector('.productATCPrice').textContent = price(total);

        // update url with variant id so the selected options are maintained on refresh
        let url = new URL(window.location.href);
        url.searchParams.set("variant", activeVariant.id);
        window.history.replaceState({}, "", url);
    }

    // on load, update the product
    // this accomplishes loading the correct variant image and price on page load
    await updateProduct().catch(e => console.error(e));

    firstRun = false;

    /**************
     Product ATC
     ***************/

    section.querySelector('.productATC').addEventListener("click", async function () {
        // if button is oos, open swal
        if (this.classList.contains("oos")) {
            // swal request email
            const {value: email} = await Swal.fire({
                title: 'Notify me back in stock',
                input: 'email',
                inputPlaceholder: 'Email Address',
                confirmButtonText: 'Notify Me',
                showCancelButton: true,
            });

            // if no email, exit
            if (!email) {
                return;
            }

            // send to klaviyo
            sendKlaviyoBackInStockRequest(email, activeVariant.id);

            // show success message
            await Swal.fire({
                title: 'Success!',
                text: 'You will be notified when this product is back in stock.',
                confirmButtonText: 'OK',
            });

            return;
        }

        // add loading animation to both buttons
        section.querySelector(".productATC").classList.add("loading");

        let formData = {
            items: [{
                quantity: 1,
                id: activeVariant.id,
            }]
        };

        // check for selling plan
        if (isSubscription()) {
            formData.items[0].selling_plan = currentSellingPlan()
        }

        // add product
        await addProduct(formData);

        // remove loading animation
        section.querySelector(".productATC").classList.remove("loading");

        // open cart
        await openCart();
    });

    /** Block - Dropdown **/

    // setup dropdowns
    section.querySelectorAll(".productDropsItemButton").forEach(element => {
        element.addEventListener("click", function () {
            this.classList.toggle("active");
        });
    });
}());

(function(){
    var out = document.getElementById('ship-date-by');
    if(!out) return;

    var days = 2;
    var d = new Date();
    d.setDate(d.getDate() + days);

    var fmt = new Intl.DateTimeFormat(undefined, {
      weekday: 'short', month: 'short', day: 'numeric'
    });

    out.textContent = fmt.format(d).trim();
})();

(function () {
  function ready(fn){ document.readyState !== 'loading' ? fn() : document.addEventListener('DOMContentLoaded', fn); }

  ready(function () {
    const form = document.getElementById('productDynamic');
    if (!form) return;

    const sellingPlanHidden = form.querySelector('#subscriptionSellingPlan');
    if (!sellingPlanHidden) return;

    const optionRadios = Array.from(document.querySelectorAll('.productFormOptionsItemValuesLabelInput'));
    const subLabel = document.querySelector('.productFormSellingOption');
    const subCheckbox = subLabel ? subLabel.querySelector('.productFormSellingOptionHeaderInput') : null;

    if (!optionRadios.length || !subCheckbox) return;

    // ---- helpers ----
    const getCurrentRadio = () => optionRadios.find(r => r.checked) || optionRadios[0] || null;
    const getPlanFromRadio = (radio) => (radio && radio.dataset && radio.dataset.id) ? radio.dataset.id : '';

    // Remembered plan id (used when toggling subscription off/on)
    let rememberedPlanId = '';

    // ---- INIT ----
    // If you want the *second* radio as the initial source, prefer that; fall back to checked one.
    const initialRadio = optionRadios[1] || getCurrentRadio();
    rememberedPlanId = getPlanFromRadio(initialRadio);

    if (subCheckbox.checked) {
      // Subscription ON at load: push plan id into hidden
      sellingPlanHidden.value = rememberedPlanId;
    } else {
      // Subscription OFF at load: clear hidden
      sellingPlanHidden.value = '';
    }

    // ---- RADIO CHANGES ----
    // Always keep the "remembered" plan id in sync with the currently selected radio.
    // If subscription is ON, also push it into the hidden input immediately.
    optionRadios.forEach(radio => {
      radio.addEventListener('change', function () {
        rememberedPlanId = getPlanFromRadio(this);
        if (subCheckbox.checked) {
          sellingPlanHidden.value = rememberedPlanId; // may be '' for one-time options
        }
      });
    });

    // Some themes switch radios on label click without firing 'change' immediately;
    // this keeps behavior snappy. (Safe no-op if change already fires.)
    const optionLabels = Array.from(document.querySelectorAll('.productFormOptionsItemValuesLabel'));
    optionLabels.forEach(label => {
      label.addEventListener('click', function () {
        const radio = this.querySelector('.productFormOptionsItemValuesLabelInput');
        if (!radio) return;
        rememberedPlanId = getPlanFromRadio(radio);
        if (subCheckbox.checked) {
          sellingPlanHidden.value = rememberedPlanId;
        }
      });
    });

    // ---- SUBSCRIPTION TOGGLE ----
    // When turning OFF: remember current plan (from hidden or current radio), then clear hidden.
    // When turning ON: restore remembered plan (or pull from current radio if empty).
    subCheckbox.addEventListener('change', function () {
      const currentRadio = getCurrentRadio();
      const currentPlanFromRadio = getPlanFromRadio(currentRadio);

      if (!this.checked) {
        // OFF → store what's currently active (prefer hidden, otherwise from radio)
        rememberedPlanId = sellingPlanHidden.value || currentPlanFromRadio || '';
        sellingPlanHidden.value = ''; // clear to indicate one-time purchase
      } else {
        // ON → restore (prefer remembered; if somehow empty, use current radio)
        if (!rememberedPlanId) rememberedPlanId = currentPlanFromRadio || '';
        sellingPlanHidden.value = rememberedPlanId;
      }
    });

    // Also respond to clicks on the wrapping label (in case browser toggles via label)
    if (subLabel) {
      subLabel.addEventListener('click', function (e) {
        // Let the checkbox toggle first, then run the same logic (microtask delay)
        setTimeout(() => {
          const currentRadio = getCurrentRadio();
          const currentPlanFromRadio = getPlanFromRadio(currentRadio);

          if (!subCheckbox.checked) {
            rememberedPlanId = sellingPlanHidden.value || currentPlanFromRadio || '';
            sellingPlanHidden.value = '';
          } else {
            if (!rememberedPlanId) rememberedPlanId = currentPlanFromRadio || '';
            sellingPlanHidden.value = rememberedPlanId;
          }
        }, 0);
      });
    }
  });
})();